const MinutesFormatter = minutes => {
	return `${parseInt(minutes / 60)}h ${minutes % 60}m`;
}

export default MinutesFormatter;
